import { createContext } from '@lit-labs/context';

import { Message } from '@gameon/on-ui-components/types';

type NotificationContext = {
  lastSeenMessageTimestamp?: number;
  unreadMessages: Message[];
};

export const notificationsContext =
  createContext<NotificationContext>('lastSeenMessage');
